import { reservationServices } from "src/services/sales/reservation/reservation.service";



export const getBaseToBilling = async (currentWorkUnit, businessUnitTokens = [], businessUnitIds = []) => {
  const varName = "Todas";

  if (!currentWorkUnit.length) {
      return [{ name: varName, value: 'all' }];
  }

  let alternativeBasesBusinessUnit = [];
  let alternativeBasesWorkUnit = [];
  const hasAllToken = businessUnitTokens.includes('all');
  if (!hasAllToken && businessUnitIds.length) {
    alternativeBasesBusinessUnit = await reservationServices.get_multiple_alternative_bases({ business_unit_id: businessUnitIds });
  }

  const workUnitIds = currentWorkUnit.map(workUnit => workUnit?.id);

  if (workUnitIds.length) {
    alternativeBasesWorkUnit = await reservationServices.get_multiple_alternative_bases({ work_unit_id: workUnitIds });
  }

  const uniqueOptions = [...new Set([...alternativeBasesBusinessUnit, ...alternativeBasesWorkUnit])];

  return [{ name: varName, value: 'all' }, ...uniqueOptions.map(option => ({ name: option, value: option }))];
}